import React from "react"
import { useRecoilState } from "recoil"
// import currentUser from "../../store/currentUser"
import currentAssociation from "../../store/currentAssociation"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"

import DocumentsSendPreview from "./DocumentsSendPreview"
import Layout from "../../components/AuthenticatedLayout"
import SendDocumentsForm from "../../forms/SendDocuments"

const useStyles = makeStyles((theme) => ({
  root: {
    clear: "both",
    marginBottom: theme.spacing(5),
    maxWidth: 742,
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
}))

const DocumentsSend = () => {
  const classes = useStyles()
  const [association] = useRecoilState(currentAssociation)
  const [preview, setPreview] = React.useState(false)
  const [sendData, setSendData] = React.useState({
    association: {
      id: association.id,
      name: association.name,
    },
    fields: {},
  })

  return (
    <Layout title="Send Documents">
      <Container className={classes.root}>
        {!preview ? (
          <SendDocumentsForm
            sendData={sendData}
            setSendData={setSendData}
            setPreview={setPreview}
          />
        ) : (
          <DocumentsSendPreview sendData={sendData} />
        )}
      </Container>
    </Layout>
  )
}

export default DocumentsSend
